import * as React from "react";
import uncheck from '../../../resources/img/checkbox/checkbox_unchecked.png'
import check from '../../../resources/img/checkbox/checkbox_checked.png'
import PopDetail from "../../popdetail";
import AddNewProjectPane from "./add_new_project_pane";
import ReadService from "../../../service/read";
import Wait from "../../wait";
import SecondLayer from "../../container/second_layer";
import ProjectContainer from "./project_container";
import {ProjectsService} from "../../../service/v1/projects";
import {AuthorizationService} from "../../../service/v1/authorization";
import jwt_decode from "jwt-decode";
import {LocalitiesService} from "../../../service/v1/localities";
import GeneralSelect from "../../general_select";
import {SpatialService} from "../../../service/v1/spatial";
import CreateService from "../../../service/create";

class ProjectListPane extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            rc_codes: [],
            userToSearch: '',
            modules: [],//'All Projects','Village LU','District LU','Regional LU','Zonal LU','National LU','CCRO','Urasimishaji'
            projects: [],
            syncBtn: 'Sync All',
            current_tab: 0,
            totalPages: 1,
            next: null,
            previous: null,
            pageSize: 50,
            newPageSize: 50,
            projectOptions: {
                endpoint: `projects/project-types`,
                value: 'id',
                label: 'name',
                placeholder: 'Select Project type'
            },

            projectStatus: {
                endpoint: `projects/project-status`,
                value: 'id',
                label: 'name',
                placeholder: 'Select Project status'
            },
            project_type: {value: 0},
            project_status: {value: 0},
            detailViewActive: false,
            selectedFile: null,
            isImporting: false,
        }

        ProjectListPane.self = this
        this.fetchProjects = this.fetchProjects.bind(this)
        this.fetchProjectsByUrl = this.fetchProjectsByUrl.bind(this)

        this.handleChange = this.handleChange.bind(this)
        this.generalSelect = this.generalSelect.bind(this)
        ProjectListPane.loadData = ProjectListPane.loadData.bind(this)
        this.submit = this.submit.bind(this)
        this.hideDetailView = this.hideDetailView.bind(this);
        this.handleFileSelect = this.handleFileSelect.bind(this);
        this.handleImportProjects = this.handleImportProjects.bind(this);
    }

    handleChange = (e) => {
        this.setState({[e.target.name]: e.target.value})
    }

    toggleCheck(i, userId) {
        let doc = document.getElementById('chk_' + i);
        if (doc.src === uncheck) {
            doc.src = check;

            return;
        }
        doc.src = uncheck;
    }

    componentDidMount() {
        ProjectListPane.loadData()
    }

    generalSelect(data, name) {
        this.setState({
            [name]: data
        })
    }

    static self;

    static loadData() {
        try {
            Wait.show('Loading...')
            ProjectsService.fetchProjects().then(r => {
                Wait.dismiss()
                try {
                    let modules = [{name: 'All', id: 0}]
                    r.data.results.forEach(d => modules.push(d))
                    ProjectListPane.self.setState({modules: modules})
                } catch (e) {
                    console.log(e)
                }

                ProjectListPane.self.fetchProjects(0, {name: 'All', id: 0})

            })

        } catch (e) {
            console.log(e)
        }
    }

    fetchProjects(i = 0, d) {
        //this.setState({current_tab:i})
        try {
            Wait.show('Fetching Projects...')
            ProjectsService.fetchProjects(this.props.moduleId).then(r => {
                Wait.dismiss()
                try {
                    //console.log(r.data)
                    this.setState({
                        projects: r.data.results,
                        totalPages: Math.ceil(r.data.count / this.state.pageSize),
                        next: r.data.next,
                        previous: r.data.previous
                    })
                } catch (e) {
                    console.log(e)
                }
            })
        } catch (e) {
            console.log(e)
        }
    }

    fetchProjectsByUrl(url) {
        try {
            Wait.show('Fetching Projects...')
            ProjectsService.fetchProjectsByUrl(url).then(r => {
                Wait.dismiss()
                try {
                    this.setState({
                        projects: r.data.results,
                        totalPages: Math.ceil(r.data.count / this.state.pageSize),
                        next: r.data.next,
                        previous: r.data.previous
                    })
                } catch (e) {
                    console.log(e)
                }
            })
        } catch (e) {
            console.log(e)
        }
    }

    hideDetailView() {
        this.setState({ detailViewActive: false });
    }

    // handleFileSelect(event) {
    //     const file = event.target.files[0];
    //     console.log('File selected:', file);
        
    //     if (file && (
    //         file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
    //         file.type === 'application/vnd.ms-excel'
    //     )) {
    //         console.log('Valid Excel file selected:', file.name, file.type, file.size);
    //         this.setState({ selectedFile: file });
    //         // Automatically submit the file when selected
    //         this.handleImportProjects(file);
    //     } else {
    //         console.log('Invalid file type:', file ? file.type : 'No file');
    //         alert('Please select a valid Excel file (.xlsx or .xls)');
    //         event.target.value = '';
    //     }
    // }
    
    // handleImportProjects(fileToUse = null) {
    //     const file = fileToUse || this.state.selectedFile;
    //     if (!file) {
    //         alert('Please select a file first');
    //         return;
    //     }
    
    //     const accessToken = sessionStorage.getItem('access');
    //     if (!accessToken) {
    //         alert('Please login first');
    //         return;
    //     }
    
    //     this.setState({ isImporting: true });
        
    //     const formData = new FormData();
    //     formData.append('file', file);
    //     formData.append('excel_file', file);  
    //     formData.append('document', file);    
    
    //     console.log('File being sent:', file);
    //     console.log('File name:', file.name);
    //     console.log('File type:', file.type);
    //     console.log('File size:', file.size);
    
    //     fetch('http://154.118.227.140:8002/api/v1/projects/create', {
    //         method: 'PUT',
    //         headers: {
    //             'Authorization': `Bearer ${accessToken}`
    //         },
    //         body: formData,
    //     })
    //     .then(response => {
    //         console.log('PUT Response status:', response.status);
    //         return response.json();
    //     })
    //     .then(data => {
    //         console.log('PUT Response data:', data);
    //         if (data.success === false) {
    //             throw new Error(data.message || 'Import failed');
    //         }
    //         alert('Projects imported successfully!');
    //         this.setState({ 
    //             selectedFile: null, 
    //             isImporting: false 
    //         });
    //         ProjectListPane.loadData();
    //         document.getElementById('fileInput').value = '';
    //     })
    //     .catch(error => {
    //         console.error('Error with PUT method:', error);
    //         alert(`Failed to import projects: ${error.message || error}`);
    //         this.setState({ isImporting: false });
    //     });
    // }
    
    handleFileSelect(event) {
        const file = event.target.files[0];
        console.log('File selected:', file);
        
        if (file && (
            file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
            file.type === 'application/vnd.ms-excel'
        )) {
            console.log('Valid Excel file selected:', file.name, file.type, file.size);
            this.setState({ selectedFile: file });
            this.handleImportProjects(file);
        } else {
            console.log('Invalid file type:', file ? file.type : 'No file');
            alert('Please select a valid Excel file (.xlsx or .xls)');
            event.target.value = '';
        }
    }
    
    handleImportProjects(fileToUse = null) {
        const file = fileToUse || this.state.selectedFile;
        if (!file) {
            alert('Please select a file first');
            return;
        }
    
        const accessToken = sessionStorage.getItem('access');
        if (!accessToken) {
            alert('Please login first');
            return;
        }
    
        this.setState({ isImporting: true });
        
        const formData = new FormData();
        formData.append('file', file);
        formData.append('excel_file', file);
        formData.append('document', file);
    
        console.log('File being sent:', file);
        fetch('https://nluis.nlupc.go.tz/api/v1/projects/create', {
        // fetch('http://154.118.227.140:8002/api/v1/projects/create', {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${accessToken}`
            },
            body: formData,
        })
        .then(async response => {
            console.log('PUT Response status:', response.status);
    
            // Parse JSON safely
            let data;
            try {
                data = await response.json();
            } catch (e) {
                throw new Error(`Invalid server response (status ${response.status})`);
            }
    
            // Handle non-OK HTTP codes
            if (!response.ok) {
                throw new Error(data.message || data.error || `Request failed with status ${response.status}`);
            }
    
            return data;
        })
        .then(data => {
            console.log('PUT Response data:', data);
    
            if (data.success === false) {
                throw new Error(data.message || 'Import failed');
            }
    
            alert(data.message || 'Projects imported successfully!');
            this.setState({ 
                selectedFile: null, 
                isImporting: false 
            });
            ProjectListPane.loadData();
            document.getElementById('fileInput').value = '';
        })
        .catch(error => {
            console.error('Error with PUT method:', error);
            alert(error.message || 'An unknown error occurred while importing projects.');
            this.setState({ isImporting: false });
        });
    }
    




    // handleFileSelect(event) {
    //     const file = event.target.files[0];
    //     console.log('File selected:', file);
        
    //     if (file && (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
    //                  file.type === 'application/vnd.ms-excel')) {
    //         console.log('Valid Excel file selected:', file.name, file.type, file.size);
    //         this.setState({ selectedFile: file });
    //         // Automatically submit the file when selected
    //         this.handleImportProjects(file);
    //     } else {
    //         console.log('Invalid file type:', file ? file.type : 'No file');
    //         alert('Please select a valid Excel file (.xlsx or .xls)');
    //         event.target.value = '';
    //     }
    // }

    // handleImportProjects(fileToUse = null) {
    //     const file = fileToUse || this.state.selectedFile;
    //     if (!file) {
    //         alert('Please select a file first');
    //         return;
    //     }

    //     // Check if user is authenticated
    //     const accessToken = sessionStorage.getItem('access');
    //     if (!accessToken) {
    //         alert('Please login first');
    //         return;
    //     }

    //     this.setState({ isImporting: true });
        
    //     const formData = new FormData();
    //     formData.append('file', file);
    //     formData.append('excel_file', file);  // Try alternative field name
    //     formData.append('document', file);    // Try another alternative field name
        
    //     // Debug: Log what's being sent
    //     console.log('File being sent:', file);
    //     console.log('File name:', file.name);
    //     console.log('File type:', file.type);
    //     console.log('File size:', file.size);

    //     // Try multiple approaches - first with POST method using existing service
    //     CreateService.uploadFile('projects/create', formData).then(r => {
    //         console.log('Response:', r);
    //         console.log('Response data:', r.data);
            
    //         if (r.data && r.data.success === false) {
    //             throw new Error(r.data.message || 'Import failed');
    //         }
            
    //         alert('Projects imported successfully!');
    //         this.setState({ 
    //             selectedFile: null, 
    //             isImporting: false 
    //         });
    //         // Refresh the project list
    //         ProjectListPane.loadData();
    //         // Clear the file input
    //         document.getElementById('fileInput').value = '';
    //     }).catch(error => {
    //         console.error('Error with POST method:', error);
            
    //         // If POST fails, try with PUT method
    //         console.log('Trying PUT method...');
    //         const accessToken = sessionStorage.getItem('access');
            
    //         fetch('http://154.118.227.140:8002/api/v1/projects/create', {
    //             method: 'PUT',
    //             headers: {
    //                 'Authorization': `Bearer ${accessToken}`
    //             },
    //             body: formData,
    //         })
    //         .then(response => {
    //             console.log('PUT Response status:', response.status);
    //             return response.json();
    //         })
    //         .then(data => {
    //             console.log('PUT Response data:', data);
    //             if (data.success === false) {
    //                 throw new Error(data.message || 'Import failed');
    //             }
    //             alert('Projects imported successfully!');
    //             this.setState({ 
    //                 selectedFile: null, 
    //                 isImporting: false 
    //             });
    //             // Refresh the project list
    //             ProjectListPane.loadData();
    //             // Clear the file input
    //             document.getElementById('fileInput').value = '';
    //         })
    //         .catch(putError => {
    //             console.error('Error with PUT method:', putError);
    //             alert(`Failed to import projects: ${putError.message || putError}`);
    //             this.setState({ isImporting: false });
    //         });
    //     });
    // }

    render() {
        // Get All locality levels and put to session
        LocalitiesService.fetchLocalityLevel().then(r => {
            Wait.dismiss()
            try {
                let response = JSON.stringify(r.data.results)
                //console.log('HAPA : ' + response)
                JSON.parse(response).forEach(level => {
                    if (JSON.stringify(level.name).toString().toLowerCase().includes("nation")) {
                        sessionStorage.setItem('national_level_id', level.id)
                    }
                    if (JSON.stringify(level.name).toString().toLowerCase().includes("zone")) {
                        sessionStorage.setItem('zonal_level_id', level.id)
                    }
                    if (JSON.stringify(level.name).toString().toLowerCase().includes("region")) {
                        sessionStorage.setItem('regional_level_id', level.id)
                    }
                    if (JSON.stringify(level.name).toString().toLowerCase().includes("district")) {
                        sessionStorage.setItem('district_level_id', level.id)
                    }
                    if (JSON.stringify(level.name).toString().toLowerCase().includes("village")) {
                        sessionStorage.setItem('village_level_id', level.id)
                    }
                    if (JSON.stringify(level.name).toString().toLowerCase().includes("ward")) {
                        sessionStorage.setItem('ward_level_id', level.id)
                    }
                })
                //console.log('region : ' + sessionStorage.getItem('regional_level_id'))

            } catch (e) {
                console.log(e)
            }
        })

        let localityLevel = JSON.parse(sessionStorage.getItem('decoded')).locality.level
        const fontFamily = 'Poppins, Inter, Open Sans, Helvetica, Arial, sans-serif';
        const container = {
            width: '100%',
            minHeight: '100vh',
            background: '#f6f8fa',
            fontFamily,
            padding: '0 0 32px 0'
        };
        const card = {
            background: '#fff',
            borderRadius: 0,
            boxShadow: '0 6px 24px 0 rgba(57,93,154,0.15), 0 1.5px 8px 0 rgba(43,187,173,0.08)',
            padding: '18px 18px 8px 18px',
            margin: '24px 24px 16px 24px',
            maxWidth: 'calc(100% - 48px)',
            fontFamily
        };
        const filterRow = {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 8,
            alignItems: 'center',
            marginBottom: 12,
            justifyContent: 'flex-end',
            fontFamily
        };
        const input = {
            fontSize: 16,
            padding: '6px 12px',
            borderRadius: 0,
            border: '1px solid #bbb',
            minWidth: 180,
            fontFamily
        };
        const button = {
            background: 'linear-gradient(90deg, #2bbbad 0%, #395d9a 100%)',
            color: 'white',
            border: 'none',
            borderRadius: 0,
            padding: '6px 16px',
            fontWeight: 700,
            fontSize: 14,
            cursor: 'pointer',
            boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
            transition: 'background 0.2s',
            fontFamily
        };
        const tableWrap = {
            width: '100%',
            overflowX: 'auto',
            overflowY: 'auto',
            maxHeight: '70vh',
            fontFamily,
            background: '#fff',
        };
        const table = {
            width: '100%',
            borderCollapse: 'collapse',
            background: '#fff',
            borderRadius: 14,
            overflow: 'hidden',
            fontFamily
        };
        const th = {
            background: '#f6f8fa',
            color: '#395d9a',
            fontWeight: 700,
            fontSize: 15,
            padding: '6px 6px',
            borderBottom: '2px solid #e0e7ef',
            borderRight: '1px solid #e0e7ef',
            position: 'sticky',
            top: 0,
            zIndex: 2,
            fontFamily
        };
        const td = {
            fontSize: 15,
            padding: '10px 8px',
            borderBottom: '1px solid #f0f0f0',
            borderRight: '1px solid #e0e7ef',
            background: '#fff',
            fontFamily
        };
        const zebra = (i) => ({...td, background: i % 2 === 0 ? '#f7fafd' : '#fff'});
        const statusTd = {
            ...td,
            color: '#084',
            fontWeight: 'bold'
        };
        const pagination = {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 18,
            margin: '18px 0',
            fontFamily
        };
        const addBtn = {
            ...button,
            marginBottom: 8,
            float: 'left',
            padding: '6px 16px',
            fontSize: 14
        };
        return (
            <div style={container}>
                {/* Breadcrumbs */}
                <div style={{margin: '8px 0 12px 0', fontSize: 13, color: '#bbb', display: 'flex', alignItems: 'center', fontFamily}}>
                    <span style={{cursor: 'pointer', color: '#bbb', fontWeight: 600}}>Home</span>
                    <span style={{margin: '0 6px', color: '#bbb'}}>&gt;</span>
                    <span style={{color: '#395d9a', fontWeight: 600}}>Projects</span>
                </div>
                {!this.state.detailViewActive &&
                    <div style={card}>
                        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18, flexWrap: 'wrap', gap: 8, position: 'relative', zIndex: 1001}}>
                            {(sessionStorage.getItem('user_groups') === 'COORDINATOR' || sessionStorage.getItem('user_groups') === 'ADMIN') && (
                                <>
                                    <button style={addBtn} onClick={() => {
                                        PopDetail.show('Add New Project', <AddNewProjectPane loadProjects={ProjectListPane.loadData} key={new Date().getMilliseconds()}/>, 80)
                                    }}>
                                        <span className={'fa fa-plus'} /> New Project
                                    </button>
                                    <input
                                        type="file"
                                        id="fileInput"
                                        accept=".xlsx,.xls"
                                        onChange={this.handleFileSelect}
                                        style={{display: 'none'}}
                                    />
                                    <button 
                                        style={{...addBtn, marginLeft: 8, background: '#6c757d'}} 
                                        onClick={() => document.getElementById('fileInput').click()}
                                    >
                                        <span className={'fa fa-upload'} /> Import Projects
                                    </button>
                                    {this.state.selectedFile && (
                                        <span style={{marginLeft: 8, fontSize: 12, color: '#28a745', fontWeight: 600}}>
                                            ✓ {this.state.selectedFile.name}
                                        </span>
                                    )}
                                </>
                            )}
                            <GeneralSelect onChanges={(e) => this.generalSelect(e, 'project_type')} parameters={this.state.projectOptions} defaultValue={5}/>
                            <GeneralSelect onChanges={(e) => this.generalSelect(e, 'project_status')} parameters={this.state.projectStatus} defaultValue={5}/>
                            <input name={'project_name_search'} style={{...input, marginRight: 0}} onChange={this.handleChange} placeholder={'Project Name'} />
                            <button style={button} onClick={this.submit}><span className={'fa fa-search'} /> Search</button>
                        </div>
                        <div style={tableWrap}>
                            <table style={table}>
                                <thead style={{position: 'sticky', top: 0, zIndex: 5, background: '#fff'}}>
                        <tr>
                                        <th style={{...th, textAlign: 'center', background: '#fff'}}>
                                            No:
                            </th>
                                        <th style={th}>Created Date</th>
                                        <th style={{...th, position: 'sticky', left: 0, background: '#f6f8fa', zIndex: 3}}>Land Use</th>
                                        <th style={th}>Land Use Planning</th>
                                        <th style={th}>Localities</th>
                                        <th style={th}>Current Task</th>
                                        <th style={{...th, width: 150}}>Status</th>
                        </tr>
                        </thead>
                        <tbody>
                                    {this.state.projects.map((d, i) => (
                                        <tr key={i} style={{cursor: 'pointer'}} onClick={() => {
                                            this.setState({ detailViewActive: true });
                                            SecondLayer.show(d.name, <ProjectContainer project={d} taskId={this.props.taskId} key={new Date().getMilliseconds()}/>, this.hideDetailView);
                                        }}>
                                            <td style={{...zebra(i), textAlign: 'center', background: '#fff', borderRight: '1px solid #e0e7ef'}}>
                                        { this.state.next === null
                                            ? this.state.previous !== null
                                                        ? this.state.previous.split('=')[1] * this.state.pageSize + i + 1
                                                    : this.state.pageSize + i + 1
                                                : 0 + i + 1
                                        }
                                    </td>
                                            <td style={{...zebra(i), borderRight: '1px solid #e0e7ef'}}>{d.datetime}</td>
                                            <td style={{...zebra(i), color: 'darkcyan', position: 'sticky', left: 0, background: i % 2 === 0 ? '#f7fafd' : '#fff', zIndex: 2, borderRight: '1px solid #e0e7ef'}}>{d.name}</td>
                                            <td style={{...zebra(i), borderRight: '1px solid #e0e7ef'}}>{d.project_type_info.name}</td>
                                            <td style={{...zebra(i), textAlign: 'center', borderRight: '1px solid #e0e7ef'}}>{typeof d.total_locality == 'undefined' ? <span style={{color: 'darkcyan'}}>1</span> : <span style={{color: 'darkcyan'}}>{d.total_locality}</span>}</td>
                                            <td style={{...zebra(i), borderRight: '1px solid #e0e7ef'}}>{d.current_task}</td>
                                            <td style={statusTd}>{d.status_info}</td>
                                        </tr>
                                    ))}
                                    <tr>
                                        <td className={'noHover'} colSpan={8} style={{textAlign: 'center', background: '#fff', borderRight: 'none'}}>
                                            <div style={pagination}>
                                <button onClick={() => {
                                                    this.setState({ newPageSize: this.state.newPageSize - this.state.pageSize })
                                    this.fetchProjectsByUrl(this.state.previous)
                                                }} style={{...button, visibility: this.state.previous !== null ? 'visible' : 'hidden', background: '#eee', color: '#395d9a'}}>
                                                    Back
                                </button>
                                <b>{this.state.totalPages === 0 ? 0 : (this.state.newPageSize) / this.state.pageSize}/{this.state.totalPages}</b>
                                <button onClick={() => {
                                                    this.setState({ newPageSize: this.state.pageSize + this.state.newPageSize })
                                    this.fetchProjectsByUrl(this.state.next)
                                                }} style={{...button, visibility: this.state.next !== null ? 'visible' : 'hidden', background: '#eee', color: '#395d9a'}}>
                                                    Next
                                </button>
                                            </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                        </div>
                </div>
                }
            </div>
        )
    }


    submit() {
        try {
            let project_type_id = this.state.project_type.value
            let status_id = this.state.project_status.value
            let project_name = this.state.project_name_search

            console.log('Project Type')
            console.log(project_type_id)
            console.log(status_id)
            console.log(project_name)

            Wait.show('Searching Projects...')
            ProjectsService.searchProjects(project_type_id,status_id,project_name).then(r => {
                Wait.dismiss()
                try {
                    //console.log(r.data)
                    this.setState({
                        projects: r.data.results,
                        totalPages: Math.ceil(r.data.count / this.state.pageSize),
                        next: r.data.next,
                        previous: r.data.previous
                    })
                } catch (e) {
                    console.log(e)
                }
            })

        } catch (e) {
            alert(e)
        }
    }

}

export default ProjectListPane;
